
// Angular
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Afidium
import { HasEmailDataGuard } from './guards/has-email-data.guard';
import { EmailFormComponent } from './components/email-form/email-form.component';
import { ProcessingEmailComponent } from './processing-email.component';
import { EmailValidationComponent } from './components/email-validation/email-validation.component';
import { HasSyscodesGuard } from '../../shared/guards/has-syscodes.guard';
import { GuardService } from 'app/shared/services/guard/guard.service';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                pathMatch: 'full',
                component: ProcessingEmailComponent,
                canActivate: [HasSyscodesGuard, GuardService],
                data: {
                    permissionPath: 'sasha.processing.email.use',
                    redirectTo: 'sasha/home',
                }
            },
            {
                path: 'form',
                component: EmailFormComponent,
                canActivate: [HasSyscodesGuard, GuardService],
                data: {
                    permissionPath: 'sasha.processing.email.use',
                    redirectTo: 'sasha/home',
                }
            },
            {
                path: 'validation',
                component: EmailValidationComponent,
                canActivate: [HasEmailDataGuard, HasSyscodesGuard, GuardService],
                data: {
                    permissionPath: 'sasha.processing.email.use',
                    redirectTo: 'sasha/home',
                }
            },
        ]),
    ],
    exports: [
        RouterModule,
    ],
})
export class ProcessingEmailRouting { }